// extracted by mini-css-extract-plugin
export default {"type":"Category_type__YRJug","body":"Category_body__SZ9zl","btn":"Category_btn__lQH2L"};